import Phaser from 'phaser'

import CoronaBusterScene from './scenes/HuntingAlienIo'
import GameOverScene from './scenes/GameOverScene'
import StartScene from './scenes/StartScene'
import WinScene from './scenes/WinScene'
import HuntingAlienIo from './scenes/HuntingAlienIo'
import HuntingAlienIo2 from './scenes/HuntingAlienIo2'

const config = {
	type: Phaser.AUTO,
	width: 400,
	height: 620,
	physics: {
		default: 'arcade',
		arcade: {
			gravity: { y: 0 }
		}


	},

	// physics
	scale: {
		mode: Phaser.Scale.FIT,
		autoCenter: Phaser.Scale.CENTER_BOTH
	},
	scene: [StartScene, HuntingAlienIo, HuntingAlienIo2, GameOverScene, WinScene]
}

export default new Phaser.Game(config)
